import { Util } from "../../utils";
import { AgValueSetter, AgAutoCompleteEditor, AgNumericEditor, AgCheckboxComponent } from "app/components";

declare var moment: any;

export class GridFareIncidConfig {
  constructor(private pageComp: any) {
  }

  colDefFclIncid = [
    {
      headerName: '적용', field: 'activityYn',
      editable: true,
      cellRenderer: 'activityYnRenderer',
      width: 65
    },
    {
      headerName: '위치', field: 'location',
      valueGetter: params => params.data.location && params.data.location.locationCd ? '[' + params.data.location.locationCd + '] ' + params.data.location.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      editable : true,
      cellEditor: "locationEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.selectedCountry)};},
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '포워더', 
      field: 'corp',
      valueGetter: params => params.data.corp && params.data.corp.corpId ? '[' + params.data.corp.corpId + '] ' + params.data.corp.corpNm : '',
      editable : false,
      filter: "agTextColumnFilter",
      width: 170
    },
    {
      headerName: '위치구분', field: 'costTp',
      valueGetter: params => params.data.costTp == 0 ? '출발지': '도착지',
      valueSetter: params => {params.data.costTp = (params.newValue == '출발지' ? 0: 1); return true},
      editable : true,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {values: ['출발지', '도착지']},
      width: 100
    },
    {
      headerName: '운임항목', field: 'item',
      cellEditor: "costItemEditor",
      editable: true,
      valueGetter: params => params.data.item && params.data.item.itemCd ? '[' + params.data.item.itemCd + '] ' + params.data.item.itemNm : '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.costItems, 'itemCd'),
      cellEditorParams: (param) => {return {items: this.pageComp.costItemAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 250
    },
    {
      headerName: '통화',
      field: 'crncyCd',
      editable : true,
      cellEditor: "crncyEditor",
      cellRenderer: params => params.value ? params.value : '',
      cellEditorParams: (param) => {return {items: this.pageComp.currencyAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 70
    },
    {
      headerName: '20', field: 'cntr20Cost',
      width: 100,
      editable: params => !params.data.blCost,
      cellEditor: "cntr20CostEditor",
      cellRenderer: params => Util.numberFormat(params.value),
    },
    {
      headerName: '40', field: 'cntr40Cost',
      width: 100,
      editable: params => !params.data.blCost,
      cellEditor: "cntr40CostEditor",
      cellRenderer: params => Util.numberFormat(params.value),
    },
    {
      headerName: '40H', field: 'cntrHcCost',
      width: 100,
      editable: params => !params.data.blCost,
      cellEditor: "cntrHcCostEditor",
      cellRenderer: params => Util.numberFormat(params.value),
    },
    {
      headerName: 'B/L', field: 'blCost',
      width: 100,
      editable: params => !params.data.cntr20Cost && !params.data.cntr40Cost && !params.data.cntrHcCost,
      cellEditor: "blCostEditor",
      cellRenderer: params => Util.numberFormat(params.value),
    },
    {
      headerName: '저장일시',
      field: 'insDtm',
      editable: false,
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 150
    }
  ];

  frameworkCompsFclIncid = {
    locationEditor: AgAutoCompleteEditor,
    costItemEditor: AgAutoCompleteEditor,
    crncyEditor: AgAutoCompleteEditor,
    cntr20CostEditor: AgNumericEditor,
    cntr40CostEditor: AgNumericEditor,
    cntrHcCostEditor: AgNumericEditor,
    blCostEditor: AgNumericEditor,
    activityYnRenderer : AgCheckboxComponent,
  };

  colDefLclIncid = [
    {
      headerName: '적용', field: 'activityYn',
      editable: true,
      cellRenderer: 'activityYnRenderer',
      width: 65
    },
    {
      headerName: '위치', field: 'location',
      valueGetter: params => params.data.location && params.data.location.locationCd ? '[' + params.data.location.locationCd + '] ' + params.data.location.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      editable : true,
      cellEditor: "locationEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.selectedCountry)};},
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '포워더', 
      field: 'corp',
      valueGetter: params => params.data.corp && params.data.corp.corpId ? '[' + params.data.corp.corpId + '] ' + params.data.corp.corpNm : '',
      editable : false,
      filter: "agTextColumnFilter",
      width: 170
    },
    {
      headerName: '위치구분', field: 'costTp',
      valueGetter: params => params.data.costTp == 0 ? '출발지': '도착지',
      valueSetter: params => {params.data.costTp = (params.newValue == '출발지' ? 0: 1); return true},
      editable : true,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {values: ['출발지', '도착지']},
      width: 100
    },
    {
      headerName: '운임항목', field: 'item',
      cellEditor: "costItemEditor",
      editable: true,
      valueGetter: params => params.data.item && params.data.item.itemCd ? '[' + params.data.item.itemCd + '] ' + params.data.item.itemNm : '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.costItems, 'itemCd'),
      cellEditorParams: (param) => {return {items: this.pageComp.costItemAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 250
    },
    {
      headerName: '통화',
      field: 'crncyCd',
      editable : true,
      cellEditor: "crncyEditor",
      cellRenderer: params => params.value ? params.value : '',
      cellEditorParams: (param) => {return {items: this.pageComp.currencyAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 70
    },
    {
      headerName: 'CBM', field: 'cbmCost',
      width: 100,
      editable: params => !params.data.blCost,
      cellEditor: "cbmCostEditor",
      cellRenderer: params => Util.numberFormat(params.value),
    },
    {
      headerName: 'B/L', field: 'blCost',
      width: 100,
      editable: params => !params.data.cntr20Cost && !params.data.cntr40Cost && !params.data.cntrHcCost,
      cellEditor: "blCostEditor",
      cellRenderer: params => Util.numberFormat(params.value),
    },
    {
      headerName: '저장일시',
      field: 'insDtm',
      editable: false,
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 150
    }
  ];

  frameworkCompsLclIncid = {
    locationEditor: AgAutoCompleteEditor,
    costItemEditor: AgAutoCompleteEditor,
    crncyEditor: AgAutoCompleteEditor,
    cbmCostEditor: AgNumericEditor,
    blCostEditor: AgNumericEditor,
    activityYnRenderer : AgCheckboxComponent,
  };

  colDefAirIncid = [
    {
      headerName: '적용', field: 'activityYn',
      editable: true,
      cellRenderer: 'activityYnRenderer',
      width: 65
    },
    {
      headerName: '위치', field: 'location',
      valueGetter: params => params.data.location && params.data.location.locationCd ? '[' + params.data.location.locationCd + '] ' + params.data.location.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      editable : true,
      cellEditor: "locationEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.selectedCountry)};},
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '포워더', 
      field: 'corp',
      valueGetter: params => params.data.corp && params.data.corp.corpId ? '[' + params.data.corp.corpId + '] ' + params.data.corp.corpNm : '',
      editable : false,
      filter: "agTextColumnFilter",
      width: 170
    },
    {
      headerName: '위치구분', field: 'costTp',
      valueGetter: params => params.data.costTp == 0 ? '출발지': '도착지',
      valueSetter: params => {params.data.costTp = (params.newValue == '출발지' ? 0: 1); return true},
      editable : true,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {values: ['출발지', '도착지']},
      width: 100
    },
    {
      headerName: '운임항목', field: 'item',
      cellEditor: "costItemEditor",
      editable: true,
      valueGetter: params => params.data.item && params.data.item.itemCd ? '[' + params.data.item.itemCd + '] ' + params.data.item.itemNm : '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.costItems, 'itemCd'),
      cellEditorParams: (param) => {return {items: this.pageComp.costItemAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 250
    },
    {
      headerName: '통화',
      field: 'crncyCd',
      editable : true,
      cellEditor: "crncyEditor",
      cellRenderer: params => params.value ? params.value : '',
      cellEditorParams: (param) => {return {items: this.pageComp.currencyAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 70
    },
    {
      headerName: 'KG', field: 'kgCost',
      width: 100,
      editable: params => !params.data.blCost,
      cellEditor: "kgCostEditor",
      cellRenderer: params => Util.numberFormat(params.value),
    },
    {
      headerName: 'AWB', field: 'awbCost',
      width: 100,
      editable: params => !params.data.cntr20Cost && !params.data.cntr40Cost && !params.data.cntrHcCost,
      cellEditor: "awbCostEditor",
      cellRenderer: params => Util.numberFormat(params.value),
    },
    {
      headerName: '저장일시',
      field: 'insDtm',
      editable: false,
      cellRenderer: params => Util.dateFomatter(params.value),
      width: 150
    }
  ];

  frameworkCompsAirIncid = {
    locationEditor: AgAutoCompleteEditor,
    costItemEditor: AgAutoCompleteEditor,
    crncyEditor: AgAutoCompleteEditor,
    kgCostEditor: AgNumericEditor,
    awbCostEditor: AgNumericEditor,
    activityYnRenderer : AgCheckboxComponent,
  };

  colDefFareReq = [
    {
      headerName: '포워더', field: 'corp',
      valueGetter: params => params.data && params.data.corp && params.data.corp.corpId ? '[' + params.data.corp.corpId + '] ' + params.data.corp.corpNm : '',
      editable : false,
      filter: "agTextColumnFilter",
      width: 170
    },
    {
      headerName: '위치', field: 'location',
      valueGetter: params => params.data &&  params.data.location && params.data.location.locationCd ? '[' + params.data.location.locationCd + '] ' + params.data.location.name: '',
      editable : false,
      filter: "agTextColumnFilter",
      width: 190
    },
    {
      headerName: '위치구분', field: 'costTp',
      valueGetter: params => params.data && params.data.costTp == 0 ? '출발지': '도착지',
      editable : false,
      filter: "agTextColumnFilter",
      width: 100
    },
    {
      headerName: '항목수', field: 'fareIncidReqList',
      valueGetter: params => params.data && params.data.fareIncidReqList && params.data.fareIncidReqList.length > 0 ? params.data.fareIncidReqList.length: 0,
      editable : false,
      filter: "agNumberColumnFilter",
      width: 80
    },
    {
      headerName: '저장일시', field: 'insDtm',
      editable: false,
      cellRenderer: params => Util.dateFomatter(moment(params.value).format('YYYYMMDDHHmm')),
      width: 150
    }
  ];

  colDefFareReqDtlFcl = [
    {
      headerName: '운임항목', field: 'item',
      editable: false,
      valueGetter: params => params.data.item ? '[' + params.data.item.itemCd + '] ' + params.data.item.itemNm : '',
      filter: "agTextColumnFilter",
      width: 250
    },
    { 
      headerName: '통화', field: 'crncyCd',
      editable: false,
      filter: "agTextColumnFilter",
      width: 100
    },
    {
      headerName: '20', field: 'cntr20Cost',
      width: 100,
      editable: false
    },
    {
      headerName: '40', field: 'cntr40Cost',
      width: 100,
      editable: false
    },
    {
      headerName: '40H', field: 'cntrHcCost',
      width: 100,
      editable: false
    },
    {
      headerName: 'B/L', field: 'blCost',
      width: 100,
      editable: false,
    }
  ];

  colDefFareReqDtlLcl = [
    {
      headerName: '운임항목', field: 'item',
      editable: false,
      valueGetter: params => params.data.item ? '[' + params.data.item.itemCd + '] ' + params.data.item.itemNm : '',
      filter: "agTextColumnFilter",
      width: 250
    },
    { 
      headerName: '통화', field: 'crncyCd',
      editable: false,
      filter: "agTextColumnFilter",
      width: 100
    },
    {
      headerName: 'CBM', field: 'cbmCost',
      width: 100,
      editable: false
    },
    {
      headerName: 'B/L', field: 'blCost',
      width: 100,
      editable: false,
    }
  ];
  colDefFareReqDtlAir = [
    {
      headerName: '운임항목', field: 'item',
      editable: false,
      valueGetter: params => params.data.item ? '[' + params.data.item.itemCd + '] ' + params.data.item.itemNm : '',
      filter: "agTextColumnFilter",
      width: 250
    },
    { 
      headerName: '통화', field: 'crncyCd',
      editable: false,
      filter: "agTextColumnFilter",
      width: 100
    },
    {
      headerName: 'KG', field: 'kgCost',
      width: 100,
      editable: false
    },
    {
      headerName: 'AWB', field: 'awbCost',
      width: 100,
      editable: false,
    }
  ];

  

}


// WEBPACK FOOTER //
// ./src/app/containers/fare/fare-management-grid-incid.ts